import React, { useEffect } from "react";
import { Table, Switch, Space, } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStaffModel } from "../staffModel";
import { IStaffDetail, RoleIdList } from "../staffType"
import YhTag from "@/components/YhTag";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys, onChange } = useStaffModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const columns: ColumnsType<IStaffDetail> = [
        {
            // title: '序号',、
             title: Locale["SN"],
            width: 80,
            // dataIndex: 'branch',
            fixed: "left",
            render: (t, r, i) => `${i + 1}`
        }, {
            // title: '员工姓名',、
             title: Locale["Employee"],
            width: 150,
            fixed: "left",
            dataIndex: 'name',
        }, {
            // title: '账号',、
             title: Locale["Employee Account"],
            width: 180,
            ellipsis: true,
            dataIndex: 'account',
        }, {
            // title: '电话',、
             title: Locale["Contact Number"],
            width: 160,
            dataIndex: 'phone',
        }, {
            // title: '岗位',、
             title: Locale["Post"],
            width: 160,
            dataIndex: 'title',
        }, {
            // title: '角色',、
             title: Locale["System Role"],
            width: 160,
            dataIndex: 'roleIdList',
            render: (text) => text.map((item: RoleIdList) => (item.name)).toString()
        }, {
            // title: '登记时间',、
             title: Locale["Founder Time"],
            width: 160,
            dataIndex: 'createTime',
        }, {
            // title: '备注',、
             title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        }, {
            // title: '操作',、
             title: Locale["Operation"],
            width: 160,
            dataIndex: 'status',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.status == 1} onChange={(checked) => {
                        onChange(record.id as string, checked);
                    }} />
                </Space>
            ),
        }
    ];
    useEffect(() => {
        loadData().then();
    }, [])
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStaffDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.id as string]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
